import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider, useDispatch, useSelector } from 'react-redux';
import store from './Redux/Store';
import 'rsuite/Button/styles/index.css';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import { Snackbar, Alert } from '@mui/material';
import axios from 'axios';
import { Get_One_user_data } from './Redux/Actions/AuthAction';

// Global Axios Interceptor to automatically attach JWT token on all outgoing requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 1. إنشاء Network Provider مدمج
const NetworkWrapper = ({ children }) => {
  const dispatch = useDispatch();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [networkAlert, setNetworkAlert] = useState({
    open: false,
    isOnline: navigator.onLine,
  });

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setNetworkAlert({ open: true, isOnline: true });
    };

    const handleOffline = () => {
      setIsOnline(false);
      setNetworkAlert({ open: true, isOnline: false });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleCloseAlert = () => {
    setNetworkAlert((prev) => ({ ...prev, open: false }));
  };

  return (
    <>
      {children}

      {/* رسالة الشبكة على مستوى التطبيق */}
      <Snackbar
        open={networkAlert.open}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={networkAlert.isOnline ? 'success' : 'error'}>
          {networkAlert.isOnline
            ? 'Internet connection restored'
            : 'No internet connection! Some features may not work'}
        </Alert>
      </Snackbar>
    </>
  );
};

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('/firebase-messaging-sw.js')
//     .then((registration) => {
//       console.log('✅ Service Worker registered with scope:', registration.scope);
//     }).catch((err) => {
//       console.error('❌ Service Worker registration failed:', err);
//     });
// }

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <NetworkWrapper>
      <App />
    </NetworkWrapper>
  </Provider>,
);
